import { render, staticRenderFns } from "./AccountRelationship.vue?vue&type=template&id=656f419c&scoped=true"
import script from "./AccountRelationship.vue?vue&type=script&lang=js"
export * from "./AccountRelationship.vue?vue&type=script&lang=js"
import style0 from "./AccountRelationship.vue?vue&type=style&index=0&id=656f419c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656f419c",
  null
  
)

export default component.exports